<template>
  <div v-loading="loading" element-loading-spinner="el-icon-loading" class="h-screen">
    <el-card class="missing-params-card" shadow="hover" v-if="errors && errors.length">
      <div class="header">
        <el-icon class="icon">
          <i class="el-icon-warning-outline"></i>
        </el-icon>
        <span class="title">The following parameters are missing :</span>
      </div>

      <el-divider></el-divider>

      <div>
        <el-tag
          v-for="(param, index) in errors"
          :key="index"
          type="danger"
          size="medium"
          effect="dark"
          class="tag"
        >
          {{ param }}
        </el-tag>
      </div>
    </el-card>
    <el-card class="missing-params-card" shadow="hover" v-if="validationError">
      <div class="header">
        <el-icon class="icon">
          <i class="el-icon-warning-outline"></i>
        </el-icon>
        <span class="title">{{ validationError }}</span>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { postAPICall } from '../../helpers/httpHelper';
  import { loginUserInfo, setUpApplication } from '../../helpers/idpHelper';

  export default {
    name: 'MissingParameters',
    data() {
      return {
        validationError: null,
        errors: [],
        loading: true,
      };
    },
    async mounted() {
      await this.checkParams();
    },
    computed: {
      queryParams() {
        return this.$route.query;
      },
    },
    methods: {
      async checkParams() {
        try {
          let required_params = ['company_slug', 'target_url', 'type', 'idp'];
          let query_params = this.queryParams;
          required_params.forEach((param) => {
            if (!query_params[param]) {
              this.loading = false;
              this.errors.push(param);
            }
          });
          if (this.$route.query.idp === 'nimble' && !this.$route.query.authId) {
            this.loading = false;
            this.errors.push('authId');
          }
          if (!this.errors.length) {
            let input = {
              url: query_params['target_url'],
              slug: query_params['company_slug'],
              type: query_params['type'],
              idpSource: query_params['idp'],
              authId: query_params['authId'] ? query_params['authId'] : '',
            };
            let result = await this.redirectToIdp(input);
            if (result?.protocol === 'saml') {
              window.open(result.data, '_self');
              return;
            }
            await loginUserInfo(result.data);
            await setUpApplication();
            this.$store.commit('navigationOpen/setIsSideBarVisible', false, {
              root: true,
            });
            this.$store.commit('navigationOpen/setIsTopBarVisible', false, {
              root: true,
            });
            this.$router.push({ path: query_params['target_url'] });
          }
        } catch (err) {
          this.loading = false;
          this.validationError = err.message || 'Something went wrong';
        }
      },
      async redirectToIdp(params) {
        try {
          let response = await postAPICall(
            'POST',
            '/idp/external_idp_routes/redirect-to-idp',
            params
          );
          return response.data;
        } catch (err) {
          console.log('Err', err);
          throw err;
        }
      },
    },
  };
</script>

<style scoped>
  .missing-params-card {
    max-width: 600px;
    margin: 20px auto;
    border-radius: 12px;
  }

  .header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #d9534f;
  }

  .icon {
    font-size: 20px;
    margin-right: 8px;
  }

  .tag {
    margin: 4px;
  }

  .no-missing {
    text-align: center;
    margin-top: 15px;
  }
</style>
